<div class="fixed bottom-6 right-4 z-50 flex flex-col items-end gap-3">
  @if (isOpen()) {
    <div
      class="w-[22rem] max-w-[calc(100vw-3rem)] max-h-[70vh] flex flex-col bg-white rounded-2xl shadow-2xl ring-1 ring-slate-200 overflow-hidden animate-[fadeIn_0.15s_ease-out]"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="guide().title"
    >
      <!-- Header -->
      <div class="flex items-start justify-between gap-3 px-5 py-4 bg-slate-900">
        <div class="min-w-0">
          @if (guide().badge) {
            <span class="inline-block mb-1 px-2 py-0.5 rounded-full bg-indigo-500/20 text-indigo-300 text-[11px] font-semibold tracking-wide uppercase">
              {{ guide().badge }}
            </span>
          }
          <h3 class="text-white font-semibold text-base leading-tight truncate">{{ guide().title }}</h3>
          <p class="text-slate-400 text-xs mt-0.5 truncate">{{ guide().subtitle }}</p>
        </div>
        <button
          type="button"
          class="flex-shrink-0 p-1.5 rounded-full text-slate-400 hover:text-white hover:bg-white/10 transition-colors"
          aria-label="Cerrar ayuda"
          (click)="close()"
        >
          <mat-icon class="!w-5 !h-5 !text-[20px]">close</mat-icon>
        </button>
      </div>

      <!-- Body -->
      <div class="flex-1 overflow-y-auto px-5 py-4 space-y-4">
        <p class="text-sm text-slate-600 leading-relaxed">{{ guide().description }}</p>

        <ol class="space-y-3">
          @for (step of guide().steps; track step.title) {
            <li class="flex items-start gap-3">
              <span class="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-indigo-50 text-indigo-600">
                <mat-icon class="!w-[18px] !h-[18px] !text-[18px]">{{ step.icon || 'check_circle' }}</mat-icon>
              </span>
              <div class="min-w-0">
                <p class="text-sm font-semibold text-slate-800">{{ step.title }}</p>
                <p class="text-xs text-slate-500 leading-relaxed mt-0.5">{{ step.description }}</p>
              </div>
            </li>
          }
        </ol>
      </div>

      <!-- Footer -->
      @if (guide().quickActions?.length) {
        <div class="px-5 py-3 border-t border-slate-100 bg-slate-50 flex flex-wrap gap-2">
          @for (action of guide().quickActions; track action.route) {
            <button
              type="button"
              class="text-xs font-medium px-3 py-1.5 rounded-lg bg-white text-indigo-600 ring-1 ring-indigo-200 hover:bg-indigo-50 transition-colors"
              (click)="goTo(action.route)"
            >
              {{ action.label }}
            </button>
          }
        </div>
      }
    </div>
  }

  <!-- Floating Button -->
  <button
    type="button"
    class="group flex items-center justify-center w-11 h-11 rounded-full bg-indigo-600 text-white shadow-lg shadow-indigo-600/30 hover:bg-indigo-700 hover:scale-105 active:scale-95 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300 transition-all duration-150"
    [attr.aria-expanded]="isOpen()"
    aria-label="Abrir asistente de ayuda"
    (click)="toggle()"
  >
    <mat-icon class="!w-6 !h-6 !text-[24px] transition-transform duration-150 group-hover:rotate-6">
      {{ isOpen() ? 'close' : 'help_outline' }}
    </mat-icon>
  </button>
</div>
